<dx-popup
  [showCloseButton]="false"
  [fullScreen]="fullScreen"
  [width]="width"
  [height]="height"
  [title]="title"
  [visible]="popupVisible"
  [disabled]="isBusy"
  (onShowing)="showing.emit()"
  (onShown)="shown.emit()">

  <div class="header-buttons">
    <dx-button *ngIf="canComplete" [text]="languageService.LNG('Label.Button.Complete')" (onClick)="completeClicked.emit()"></dx-button>
    <dx-button *ngIf="canSave" icon="check" [text]="languageService.LNG('Label.Button.Save')" [disabled]="!saveEnabled" (onClick)="saveClicked.emit()"></dx-button>
    <dx-button *ngIf="canRefresh" icon="refresh" [text]="languageService.LNG('Label.Refresh')" (onClick)="refreshClicked.emit()"></dx-button>
    <dx-button *ngIf="canDelete" icon="trash" [text]="languageService.LNG('Label.Button.Delete')" (onClick)="deleteClicked.emit()"></dx-button>
    <dx-button icon="close" [text]="languageService.LNG('Label.Button.Close')" (onClick)="closeClicked.emit()"></dx-button>
  </div>
  <div class="popup-content">
    <ng-content></ng-content>
  </div>
</dx-popup>
